export const sources = {
	webp: "__VITE_ASSET__eBB5uVE_t2Bb1etqpZE3Ig__ 500w, __VITE_ASSET__OxgPY7jd89vmgHQlmb5h_Q__ 800w, __VITE_ASSET__Ngmgj7KrmSrUoXH_NFNtFA__ 1080w, __VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__ 1600w, __VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__ 2000w, __VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__ 2600w, __VITE_ASSET__cLLFq7OX38PQjR0WE41fig__ 3000w"
};
export const img = {
	src: "__VITE_ASSET__cLLFq7OX38PQjR0WE41fig__",
	w: 3000,
	h: 2250
};
export default {
	sources: sources,
	img: img
};
